import React, { useRef } from 'react';
import useInPageAnchors from './hooks/useInPageAnchors';
import useRevealOnScroll from './hooks/useRevealOnScroll';
import useTiltCards from './hooks/useTiltCards';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import ui from './styles/primitives.module.css';

// Shell for the public DS360 pages: header, footer and the shared scroll/reveal/tilt behaviour.
// Pages render their sections as children; each page should include a <ScheduleCall /> (#call).
const SiteLayout = ({ children }) => {
  const rootRef = useRef(null);
  useRevealOnScroll(rootRef);
  useTiltCards(rootRef);
  useInPageAnchors(rootRef);

  return (
    <div ref={rootRef} className={ui.root}>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
